import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import SimpleBackdrop from "../../utils/general.js";
import api from "../../utils/api.js";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant.js";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import Loader from "components/Shared/Loader/Loader";
import { Autocomplete } from "@material-ui/lab";
class HSNCodeMaster extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      MasterID: "",
      loading: false,
      UserId: "",
      Token: "",
      GetMasterList: [],
      rowsPerPageOptions: CommonConfig.dataTableConfig.rowsPerPageOptions,
      rowsPerPage: CommonConfig.dataTableConfig.rowsPerPage,
      search: null,

      hsnCodeName: "",
      gst: "",
      description: "",

      AddMasterModal: false,
      EditMasterTypeModal: false,
      DeleteMasterTypeModal: false,
      cargoTypeList: [],
      gstList: [],
      userPageAccess: [],
    };
  }

  componentDidMount = async () => {
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");
    // if (lockstatus == 0) {
    if (token !== null) {
      this.setState({
        UserId: data,
        Token: token,
        userPageAccess: userPageAccess,
      });
      await this.GetMasterListByType(data);
      await this.GetGSTMaster(data);
    } else {
      this.props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  };

  actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {this.state.userPageAccess.includes("Edit HSN Code") ? (
          <div onClick={(e) => this.handleOpen(rowData, "EditMasterType")}>
            {" "}
            <i class="icon-editImage"></i>{" "}
          </div>
        ) : null}
        {this.state.userPageAccess.includes("Delete HSN Code") ? (
          <div onClick={(e) => this.handleOpen(rowData, "DeleteMasterType")}>
            {" "}
            <i class="icon-delete"></i>{" "}
          </div>
        ) : null}
      </div>
    );
  };

  GetMasterListByType = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          this.setState({ GetMasterList: response.Data });
        }
      })
      .catch((err) => {});
  };

  GetHSNCodeMasterById = async (MasterId) => {
    Loader.show();
    let params = {
      ID: MasterId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMasterById, params)
      .then((response) => {
        if (response.Success === 1) {
          Loader.hide();

          this.setState({
            hsnCodeName: response.Data.HSNCodeName,
            gst: response.Data.GST,
            description: response.Data.Description,
            MasterID: response.Data.HSNCodeMasterId,
          });
        } else {
          Loader.hide();
        }
      })
      .catch((err) => {
        Loader.hide();
      });
  };

  GetGSTMaster = async (UserId) => {
    let params = {
      ID: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          this.setState({ gstList: filterArry });
        }
      })
      .catch((err) => {});
  };

  handleOpen = (item, type) => {
    if (type === "AddMaster") {
      this.setState({ AddMasterModal: true });
    } else if (type === "EditMasterType") {
      this.GetHSNCodeMasterById(item.HSNCodeMasterId);
      this.setState({
        AddMasterModal: true,
        MasterLabelName: item.label,
        MasterID: item.HSNCodeMasterId,
      });
    } else if (type === "DeleteMasterType") {
      this.setState({
        DeleteMasterTypeModal: true,
        MasterID: item.HSNCodeMasterId,
      });
    }
  };

  handleClose = (type) => {
    if (type === "AddMaster") {
      this.setState({
        AddMasterModal: false,

        hsnCodeName: "",
        hsnCodeNameErr: false,
        hsnCodeNameErrText: "",

        gst: "",
        description: "",

        MasterID: "",
      });
    } else if (type === "EditMasterType") {
      this.setState({ EditMasterTypeModal: false });
    } else if (type === "DeleteMasterType") {
      this.setState({ DeleteMasterTypeModal: false, MasterID: "" });
    }
  };

  handleChange = (e, type) => {
    if (type === "hsnCodeName") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          hsnCodeName: e.target.value,
          hsnCodeNameErr: true,
          hsnCodeNameErrText: `Please enter HSN Code Name.`,
        });
      } else {
        if (/^\d*$/i.test(e.target.value)) {
          this.setState({
            hsnCodeName: e.target.value,
            hsnCodeNameErr: false,
            hsnCodeNameErrText: "",
          });
        }
      }
    } else if (type === "gst") {
      if (CommonConfig.isObjectEmpty(e)) {
        this.setState({
          gst: "",
        });
      } else {
        this.setState({
          gst: e.value,
        });
      }
    } else if (type === "description") {
      if (CommonConfig.isObjectEmpty(e.target.value)) {
        this.setState({
          description: "",
        });
      } else {
        this.setState({
          description: e.target.value,
        });
      }
    }
  };

  validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(this.state.hsnCodeName)) {
      this.setState({
        hsnCodeName: "",
        hsnCodeNameErr: true,
        hsnCodeNameErrText: "HSN Code Name is required.",
      });
      formIsValid = false;
    } else {
      this.setState({ hsnCodeNameErr: false, hsnCodeNameErrText: "" });
    }

    return formIsValid;
  };

  AddMaster = () => {
    if (this.validation()) {
      this.setState({ loading: true });
      let params = {
        HSNCodeName: this.state.hsnCodeName,
        GST: this.state.gst,
        GSTName: this.state.gst
          ? this.state.gstList.find((item) => item.value === this.state.gst)
              .label
          : "",
        Description: this.state.description,
        HSNCodeMasterID: this.state.MasterID,
        UserID: this.state.UserId,
      };
      api.post(APIConstant.path.AddUpdateHSNCodeMaster, params).then((res) => {
        this.setState({
          loading: false,
        });
        if (res.Success == 1) {
          this.handleClose("AddMaster");
          this.GetMasterListByType(this.state.UserId);
          cogoToast.success(res.Message);
        } else {
          cogoToast.error(res.Message);
        }
      });
    }
  };

  DeleteMasterType = () => {
    this.setState({ loading: true });
    let params = {
      ID: this.state.MasterID,
      UserId: this.state.UserId,
    };
    api.post(APIConstant.path.DeleteHSNCodeMaster, params).then((res) => {
      if (res.Success == 1) {
        this.setState({
          loading: false,
          DeleteMasterTypeModal: false,
          MasterID: "",
        });
        this.GetMasterListByType(this.state.UserId);
        cogoToast.success(res.Message);
      } else {
        this.setState({ loading: false });
        cogoToast.error(res.Message);
      }
    });
  };
  GetCargoTypeList = (UserId) => {
    let params = {
      Type: "CARGOTYPE",
      ID: UserId,
    };
    api.post(APIConstant.path.GetMasterListByType, params).then(async (res) => {
      if (res.Success === 1) {
        this.setState({ cargoTypeList: res.Info.Master });
      }
    });
  };

  render() {
    const {
      gstList,
      search,
      userPageAccess,
      GetMasterList,
      AddMasterModal,
      DeleteMasterTypeModal,
      MasterID,

      hsnCodeName,
      hsnCodeNameErr,
      hsnCodeNameErrText,
      gst,
      description,
    } = this.state;

    let filterGetMasterList = [];
    if (GetMasterList.length) {
      filterGetMasterList = GetMasterList;
      if (search) {
        filterGetMasterList = filterGetMasterList.filter((x) => {
          return (
            x.HSNCodeName.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
            x.GSTName.toLowerCase().indexOf(search.toLowerCase()) !== -1
          );
        });
      }
    }

    return (
      <div className="wayment-owner-dashboard e-weighment-dashoard">
        <div className="heading-area p-d-flex p-ai-center p-jc-between">
          <div className="p-d-flex p-ai-center">
            <i className="pi pi-share-alt"></i>
            <h2>HSN Code Master</h2>
          </div>
          <div className="p-d-flex p-ai-center wb-filter-btn">
            <div className="searchbar-area p-as-center">
              <InputText
                type="search"
                onInput={(e) => this.setState({ search: e.target.value })}
                placeholder="Global Search"
                size="30"
                style={{ marginRight: 10 }}
              />
              <i className="icon-search"></i>
            </div>
            {userPageAccess.includes("Add HSN Code") ? (
              <div>
                <div
                  className="e-add-btn"
                  onClick={(e) => this.handleOpen(e, "AddMaster")}
                >
                  <i className="icon-add"></i>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <hr />
        <div className="main-access-card-master">
          {this.state.loading === true ? (
            <div className="loading">
              <SimpleBackdrop />
            </div>
          ) : null}
          {userPageAccess.includes("View HSN Code") ? (
            <DataTable
              className="main-table table-td"
              value={filterGetMasterList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              paginator={true}
              rows={this.state.rowsPerPage}
              totalRecords={filterGetMasterList.length}
              rowsPerPageOptions={this.state.rowsPerPageOptions}
              globalFilter={search}
              emptyMessage="No records found"
              responsive={false}
              resizableColumns={true}
              columnResizeMode="fit"
              scrollable={true}
              scrollWidth="auto"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            >
              <Column
                field="Index"
                header="Sr.No"
                body={this.actionBodyTemplateSrNo}
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="HSNCodeName"
                header="HSN Code"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="GSTName"
                header="GST"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="Description"
                header="Description"
                style={{ width: "20%" }}
              ></Column>

              <Column
                field="Action"
                header="Action"
                body={this.actionTemplate}
                headerStyle={{ width: "10%", minWidth: "8rem" }}
                bodyStyle={{ textAlign: "center" }}
              ></Column>
            </DataTable>
          ) : null}

          {/* Add Edit BL Type */}
          <Dialog
            open={AddMasterModal}
            onClose={() => this.handleClose("AddMaster")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>{MasterID !== "" ? "Edit" : "Add"} HSNCode Master</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handleClose("AddMaster")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <GridContainer>
                <GridItem md={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    name="HSNCodeName"
                    label="HSN Code*"
                    type="text"
                    value={hsnCodeName}
                    onChange={(e) => this.handleChange(e, "hsnCodeName")}
                    error={hsnCodeNameErr}
                    helperText={hsnCodeNameErrText}
                    inputProps={{ maxLength: 8 }}
                    fullWidth
                  />
                </GridItem>
                <GridItem xs={12}>
                  <div className="input-control select p-d-flex">
                    <FormControl fullWidth>
                      <Autocomplete
                        id="gst"
                        name="gst"
                        value={
                          gst && gstList.length
                            ? gstList.filter((y) => y.value == gst)[0]
                            : ""
                        }
                        options={gstList}
                        getOptionLabel={(option) =>
                          option.label ? option.label : option
                        }
                        onChange={(e, value) => this.handleChange(value, "gst")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="GST Name"
                            label="GST Name"
                          />
                        )}
                      />
                    </FormControl>
                  </div>
                </GridItem>
                <GridItem md={12}>
                  <TextField
                    margin="dense"
                    name="description"
                    // id="chaNo"
                    label="Description"
                    type="text"
                    value={description}
                    onChange={(e) => this.handleChange(e, "description")}
                    inputProps={{ maxLength: 100 }}
                    multiline
                    minRows={2}
                    fullWidth
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handleClose("AddMaster")}
              >
                Cancel
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.AddMaster(e)}
                type="submit"
                disabled={this.state.loading}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* Modal For Delete */}
          <Dialog
            open={DeleteMasterTypeModal}
            onClose={() => this.handleClose("DeleteMasterType")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>Delete HSNCode Master</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handleClose("DeleteMasterType")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <h6>Are you sure want to delete?</h6>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handleClose("DeleteMasterType")}
              >
                Cancel
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.DeleteMasterType(e)}
                type="submit"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
export default HSNCodeMaster;
